// utils/formatTime.ts
/**
 * 将秒数转换为时分秒格式（不足两位补零）
 * @param seconds 总秒数
 * @returns 格式化后的时间字符串，格式：HH:MM:SS 或 MM:SS
 */
export function formatTime(seconds: number): string {
  if (seconds < 0 || isNaN(seconds)) return '00:00';

  // 计算时分秒
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  // 补零函数
  const pad = (num: number): string => num.toString().padStart(2, '0');

  // 如果有小时，显示HH:MM:SS，否则显示MM:SS
  if (hours > 0) {
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  } else {
    return `${pad(minutes)}:${pad(secs)}`;
  }
}
